import { CCopyBlockFragments } from './c-copy-block'

export const CWysiwygFragments = {
  field: `
    fragment wysiwyg on wysiwyg_MatrixField {
      ...wysiwyg_copyBlock
    }
    ${CCopyBlockFragments.wysiwygBlock}
  `,
}
